import React from "react";
import "./eventIcon.sass";
import Icon from "../../atoms/common/icon/icon";
import {IconSource} from "../../../shared/enums/iconSource";
import {RecurringStatus} from "../../../shared/enums/RecurringStatus";
import {EventHelper} from "../../../shared/eventHelper";

export interface IEventIconProps {
  recurringStatus: RecurringStatus | string;
  isVirtualEvent: boolean;
  isFeaturedEvent: boolean;
  isPreReleaseEvent: boolean;
  isPreReleaseInPastAndEventInUnreleasedPeriod: boolean;
  isPreReleaseInPastAndEventInReleasedPeriod: boolean;
  isCancelledOrPostponedEvent: boolean;
  isPastEvent: boolean;
  isBookableEvent: boolean;
}

const EventIcon: React.FC<IEventIconProps> = ({
  recurringStatus,
  isVirtualEvent,
  isFeaturedEvent,
  isPreReleaseEvent,
  isPreReleaseInPastAndEventInUnreleasedPeriod,
  isPreReleaseInPastAndEventInReleasedPeriod,
  isCancelledOrPostponedEvent,
  isPastEvent,
  isBookableEvent
}) => {
  // icon source look up
  const iconLookup: Record<string, IconSource> = {
    virtual: IconSource.virtual,
    featured: IconSource.featured,
    recurring: IconSource.series,
    detached: IconSource.detachedOccurrence,
    prerelease: IconSource.published
  };

  // default priority config
  // ascending priority => last one has highest priority
  // ie. [n-1] is overridden by [n]
  const configs: Record<string, boolean> = {
    recurring:
      recurringStatus === RecurringStatus.Series ||
      recurringStatus === RecurringStatus.DetachedSeries,
    detached: recurringStatus === RecurringStatus.DetachedOccurrence,
    virtual: isVirtualEvent,
    featured: isFeaturedEvent,
    prerelease:
      (isPreReleaseEvent && !isPreReleaseInPastAndEventInReleasedPeriod) ||
      isPreReleaseInPastAndEventInUnreleasedPeriod
  };
  // get className and iconSource
  let className: string | undefined;
  let iconSource: IconSource | undefined;

  Object.entries(configs).forEach(
    ([k, v]) => v && ([className, iconSource] = [k, iconLookup[k]])
  );

  // treat detached as recurring css-wise
  className = className === "detached" ? "recurring" : className;
  // get icon's color class name
  const colorClassName = EventHelper.getIconColorClass(
    isCancelledOrPostponedEvent,
    isPastEvent,
    EventHelper.isRecurringEvent(recurringStatus),
    isBookableEvent,
    isPreReleaseInPastAndEventInUnreleasedPeriod
  );

  return !!className && !!iconSource ? (
    <div className={`event-icon ${className}-event-icon ${colorClassName}`}>
      <Icon source={iconSource}></Icon>
    </div>
  ) : (
    <></>
  );
};

export default EventIcon;
